import {UserReportDetailDialogController, RANGE, DAYS, intradayOptions, LAST} from './UserReportDetailDialogController';

export const EDITROUTE = 'administration.editUserReport';
export const EDITTITLE = 'EDIT_USERREPORT';
import moment from 'moment';
import {REPORT_TYPE} from "../../../components/report/ReportModalController";

/** @ngInject */
export class EditUserReportController extends UserReportDetailDialogController {
    constructor($scope, userService, arsMainDependencies) {
        super($scope, userService, arsMainDependencies, "update");
    }

    loadOptionSelection() {
        // switch old xls types
        if(this.element.documentType === REPORT_TYPE.XLS_TRANSACTION_REPORT.value) {
            this.element.documentType = REPORT_TYPE.XLSX_TRANSACTION_REPORT.value;
        }
        //file Type options: MT940Y, STATEMENT REPORTS...
        this.fileType = this.fileTypeOptions.filter(fileType =>
            fileType.options.filter(type => type.value === this.element.documentType)[0])[0];
        this.fileOptionType = this.fileType.options.filter(type => type.value === this.element.documentType)[0];

        //filter options: banks, countries...
        this.filterType = this.filterOptions.filter(opt => {
            const list = this.element[opt.value.toLowerCase()];
            if(list.length > 0 ) {
                this.populateSelectionList(list, opt);
                return opt;
            }
        })[0];

        if(this.fileType.value !== intradayOptions.value) {
            //TIME filter options
            if(this.element.dateRange) {
                this.filterDateType = RANGE;
                this.element.dateRange.lowerBound = moment(this.element.dateRange.lowerBound);
                this.element.dateRange.upperBound = moment(this.element.dateRange.upperBound);
            } else {
                this.filterDateType = this.element.lastStatement ? LAST : DAYS;
            }
        }
        this.loaded = true;
    }
}
